import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=20ddb72c&"
import script from "./GlobalLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalLoader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=20ddb72c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports